import type { ComponentPropsWithoutRef } from 'react';

/**
 * A `<ul>` that keeps its list semantics everywhere. Tailwind's preflight sets `list-style: none`,
 * and Safari/VoiceOver then stops announcing "list, N items" unless the role is explicit — so every
 * navigation/menu list in the app goes through this one component.
 */
export function List(props: ComponentPropsWithoutRef<'ul'>) {
  // eslint-disable-next-line jsx-a11y-x/no-redundant-roles -- explicit role restores list semantics in VoiceOver when list-style is none
  return <ul role="list" {...props} />;
}
